import React from 'react';

import { Theme, Grid, Box, Fade } from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';

import { IImages } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    imageList: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        width: '100%',
        marginTop: '1rem',
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    currentImageContainer: {
        marginBottom: '1rem',
        height: '50vh',
        [theme.breakpoints.down('xs')]: {
            height: '30vh',
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
    image: {
        cursor: 'pointer',
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.grey[200],
        objectFit: 'contain',
    },
    listItem: {
        cursor: 'pointer',
        transition: 'transform 0.6s ease',
        '&:hover': {
            transform: 'scale(1.01)',
        },
    },
    imageListContainer: {
        maxHeight: '20vh',
        overflow: 'scroll',
    },
    imageListItem: {
        height: '8vh',
    },
}));

export const Images = ({
    medias = [],
    currentImage,
    setCurrentImage,
}: IImages) => {
    const classes = useStyles();

    return (
        <Box className={classes.mainContainer}>
            <Box className={classes.currentImageContainer}>
                <img src={medias[currentImage]} className={classes.image} />
            </Box>
            <Grid container spacing={2} className={classes.imageListContainer}>
                {medias.map((item, index) => (
                    <Grid
                        item
                        key={index}
                        xs={2}
                        className={classes.imageListItem}
                        onClick={() => setCurrentImage(index)}
                    >
                        <Fade in timeout={600}>
                            <img
                                className={classes.image}
                                src={item}
                                alt={`evidence-${index}`}
                            />
                        </Fade>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
